export default {
      id: "sli-color-palette-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.b3fb107f.svg#sli-color-palette",
      toString: function () {
        return this.url;
      }
    }